import { saveAs } from "file-saver";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
import { OpenProducts, open_products } from "../../actions/orders";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";

import json2csv from 'json2csv';
import { DownloadOutlined } from "@ant-design/icons";

const OpenOrders = () => {
  const dispatch = useDispatch();
  const open_orders_res = useSelector((state) => state?.orders?.open_prods);
  const [sku, setSku] = React.useState(undefined)
  const [filters, setFilters] = React.useState({})

  const [tableScroll, setTableScroll] = React.useState({ x: '100%' });

  useEffect(() => {

    const screenWidth = window.screen.width;
    const newScroll = screenWidth > 2400 ? { x: '100%' } : { x: 2400 };
    setTableScroll(newScroll);

  }, []);

  const sortKeys = {
    "Sales order": "SoNumber", "Ordered Date": "SoDate", "SKU": "Matnr"
  }

  // const history = useHistory();
  const columns = [
    {
      header: "IP Code",
      accessor: "Matnr",
      width: 9,
    },
    {
      header: "Rim",
      accessor: "rim",
      width: 5,
    },
    {
      header: "Size",
      accessor: "size",
      width: 11,
    },
    {
      header: "LI",
      accessor: "li",
      width: 6,
    },
    {
      header: "SR",
      accessor: "sr",
      width: 6,
    },
    {
      header: "LR",
      accessor: "lr",
      width: 6,
    },
    {
      header: "Brand",
      accessor: "brand",
      width: 8,
    },
    {
      header: "Pattern",
      accessor: "pattern",
      width: 12,
    },
    {
      header: "Application",
      accessor: "appliction",
      width: 12,
    },
    {
      header: "Sales order",
      accessor: "SoNumber",
      width: 10,
    },
    {
      header: "Order Date",
      accessor: "SoDate",
      width: 8,
      cell: (row) => (
        <span>{row.SoDate ? moment(row.SoDate, "YYYYMMDD").format("MM/DD/YY") : "-"}</span>
      ),
    },
    {
      header: "Order Type",
      accessor: "Vtweg",
      width: 8,
      cell: (row) => (row.vtweg === "41" ? "FTL" : "FD"),
    },
    {
      header: "Customer PO",
      accessor: "Bstnk",
      width: 17,
    },
    {
      header: "Temporary Order Number",
      accessor: "OrderId",
      width: 10,
    },
    {
      header: "Quantity Ordered",
      accessor: "Kwmeng",
      width: 8,
      cell: (row) => (
        <span>{row.Kwmeng ? parseInt(row.Kwmeng) : "-"}</span>
      ),
    },
    {
      header: "Delivered Quantity",
      accessor: "Deliveredqty",
      width: 8,
      cell: (row) => (
        <span>{row.Deliveredqty ? parseInt(row.Deliveredqty) : "-"}</span>
      ),
    },

    {
      header: "Pending",
      accessor: "Pendingqty",
      width: 11,
      cell: (row) => (
        <span>{row.Pendingqty ? parseInt(row.Pendingqty) : "-"}</span>
      ),
    },
  ];

  useEffect(() => {
    dispatch(
      open_products({
        email: localStorage.getItem("email"),
        page: 1,
      })
    );
    // eslint-disable-next-line
  }, []);

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={<span>Open Orders</span>}
          showGrid={false}
          searchPlaceholder={"Search..."}
          options={open_orders_res?.filters}
          onSelect={(val) => {
            dispatch(({ type: OpenProducts.CHANGED, payload: { sku: val, isFilter: true, ...filters } }));
            setSku(val?.length ? val : undefined)
          }}
          mode={"multiple"}
          sortKeys={Object.keys(sortKeys).map(key => ({
            label: key,
            value: () => {
              dispatch(({ type: OpenProducts.CHANGED, payload: { sort: "asc", key: sortKeys[key], isSort: true } }));
            }
          }))}
          value={sku}
          onClear={() => {
            setSku(undefined)
            dispatch(({ type: OpenProducts.CHANGED, payload: { sku: [], isFilter: true } }));
          }}
          exportComponent={<button onClick={() => {
            let prods = open_orders_res?.data?.open_order_products?.map(ele => ({
              "IP Code": ele.Matnr,
              "Rim": ele.rim,
              "Size": ele.size,
              "LI": ele.li,
              "SR": ele.sr,
              "LR": ele.lr,
              "Brand": ele.brand,
              "Pattern": ele.pattern,
              "Application": ele.appliction,
              "Sales Order": ele.SoNumber,
              "Order Date": ele.SoDate ? moment(ele.SoDate, "YYYYMMDD").format("MM/DD/YY") : "-",
              "Customer PO": ele.Bstnk,
              "Order Number": ele.OrderId,
              "Quantity Ordered": ele.Kwmeng,
              "Delivered Quantity": ele.Deliveredqty,
              "Pending": ele.Pendingqty,
            }));
            let csv = json2csv.parse(prods);
            var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
            saveAs(blob, "OpenOrders.csv");
          }}>
            <DownloadOutlined color="#333" />
          </button>}
          selectBox={true}
          selectPlaceHolder={"Filter By SKU"}
          // total_count={open_orders_res?.data?.pagination?.total_count}
          perPageLimit={10}
          // onPageChange={(page) => {
          //   let obj = {
          //     email: localStorage.getItem("email"),
          //     authentication_token: localStorage.getItem("token"),
          //   };
          //   dispatch(open_products({ ...obj, page: page, ...filters }));
          // }}
          callSearch={(search) => {
            dispatch(({ type: OpenProducts.CHANGED, payload: { sku, search, isSearch: true } }));
            setFilters(f => ({ ...f, search }))
          }}
          searchVal={filters.search}
        >
          <Table
            columns={columns}
            data={open_orders_res?.data?.open_order_products}
            action={false}
            actionWidth={8}
            scroll={tableScroll}
            loading={open_orders_res?.loading}
          // onRowClick={(row) => {
          //   history.push("/open-order-detail", {
          //     sku: row?.sku,
          //     prod: row,
          //   });
          // }}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default OpenOrders;
